export default __webpack_public_path__ + "static/media/Print-04.1a86d208.svg";